/* eslint-disable react/function-component-definition */
import React, { Suspense, useEffect } from "react";
import { API } from "aws-amplify";
import { Redirect, Switch, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { LayoutSplashScreen, ContentRoute } from "../_metronic/layout";
import { getLoginSettings } from "../graphql/queries";
import { SignOut } from "./pages/SignOut";
import Can from "./modules/Auth/Can";
import { AdminPage } from "./pages/AdminPage";
import NotificationPage from "./pages/NotificationPage";
import HelpCenterPage from "./pages/HelpCenterPage";
import { useNotificationContext } from "./sustell_15/context/NotificationContext";
import NotificationModal from "./sustell_15/components/notifications/NotificationModal";
import ProfileCardV2 from "./modules/UserProfile/components/ProfileCardV2";
import { SustellHomePage } from "./sustell_15/pages/SustellHomePage";
import SustellMyFarmsPage from "./sustell_15/pages/FarmFlow/SustellMyFarmsPage";
import SustellFarmPage from "./sustell_15/pages/FarmFlow/SustellFarmPage_v2";
import { AdminCustomersPage } from "./pages/AdminCustomersPage";
import FootPrintPage from "./sustell_15/pages/FootPrintPage";
import SustellDatasetMainPage2 from "./sustell_15/pages/FarmFlow/SustellDatasetMainPage_v2";
import SustellDashboardPage from "./sustell_15/pages/SustellDashboardPage";
import CompoundFeedsPage from "./sustell_15/pages/CompoundFeedsPage";
import CompoundFeedPage from "./sustell_15/pages/CompoundFeedPage";
import FarmFormPage from "./sustell_15/pages/FarmFormPage";
import SustellInterventionMainPage_v2 from "./sustell_15/pages/FarmFlow/SustellInterventionMainPage_v2";
import { SustellProdProcessDatasetsPageV2 } from "./sustell_15/pages/FarmFlow/SustellProdProcessDatasetsPage_V2";
import SustellRoiCalculatorPage from "./sustell_15/pages/FarmFlow/SustellRoiCalculatorPage";
import SustellRoiResultsPage from "./sustell_15/pages/FarmFlow/SustellRoiResultsPage";
import AccessSampleDataDialog from "./sustell_15/components/Benchmark/AccessSampleDataDialog";
import { useIntl } from "../_metronic/i18n/customUseIntl";
import HelpCenter from "./sustell_15/pages/HelpCenter";
import FacilitiesTable from "./modules/UserProfile/FacilitiesTable";
import FacilityFormPage from "./sustell_15/pages/FacilityFormPage";
import featureFlags from "./sustell_15/utils/featureFlags";
import NotificationsModal from "../_metronic/layout/components/extras/dropdowns/notifications/NotificationsModal";
import { useNotifications } from "./modules/Helpers/use-notifications";

const WelcomeModalInner = ({ open, onClose }) => {
  const { welcomeNotificationsForPopup } = useNotificationContext();
  return (
    <NotificationModal
      notifications={welcomeNotificationsForPopup}
      open={open && welcomeNotificationsForPopup.length > 0}
      onClose={onClose}
    />
  );
};

export default function BasePage() {
  const intl = useIntl();
  const notifications = useNotifications();
  const history = useHistory();
  const [open, setOpen] = React.useState(
    localStorage.getItem("notificationsViewed") !== "true",
  );
  const [requestAccessDialog, setRequestAccessDialog] = React.useState(false);
  const selectedCustomer = useSelector(
    (state) => state.selectedCustomer?.value,
  );
  const redirectFeed = (props) =>
    history.push({
      pathname: `/customers/${props.match.params.customerID}/compoundfeeds`,
      state: {},
    });
  useEffect(() => {
    const loadUserProfile = async () => {
      // This field will set true when user login next time
      localStorage.setItem("toShowRequestSampleDataDialog", "false");
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      API.graphql({
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        query: getLoginSettings,
      }).then(
        (response) => {
          const loginSettings = response.data.getUserSettings;
          if (
            (loginSettings?.numberOfLoginTimes &&
              loginSettings?.numberOfLoginTimes >= 3) ||
            loginSettings?.sampleDataAccessPopup
          ) {
            setRequestAccessDialog(false);
          } else {
            setRequestAccessDialog(true);
          }
        },
        (reason) => {
          console.log("Error fetching selected database: ", reason);
        },
      );
    };
    if (localStorage.getItem("toShowRequestSampleDataDialog") !== "false") {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      loadUserProfile();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getMyFeedsPage = (routeProps) => {
    if (featureFlags.feedV2Routing) {
      const { location } = routeProps;
      const fullPath = location.pathname + location.search;
      window.location.href = fullPath;
      return null;
    }

    return <CompoundFeedsPage {...routeProps} />;
  };

  const getMyFarmsPage = (routeProps) => {
    if (featureFlags.farmV2Routing) {
      const { location, match } = routeProps;
      const { customerID } = match.params;
      window.location.href = customerID
        ? `/v2/farms?organizationId=${customerID}`
        : location.pathname + location.search;
      return null;
    }

    return <SustellMyFarmsPage {...routeProps} />;
  };

  const getMyIngredientsPage = (routeProps) => {
    const { location } = routeProps;
    const fullPath = location.pathname + location.search;
    window.location.href = fullPath;
    return null;
  };

  const getMyProfilePage = (routeProps) => {
    const { location } = routeProps;
    const fullPath = location.pathname + location.search;
    window.location.href = fullPath;
    return null;
  };

  const usersPath = featureFlags.backofficeM1 ? "/backoffice/users" : "/admin/users";
  const customersPath = featureFlags.backofficeM1
    ? "/backoffice/organizations"
    : "/admin/customers";

  const getUsersPage = (routeProps) => {
    if (featureFlags.backofficeM1) {
      const { location } = routeProps;
      const fullPath = location.pathname + location.search;
      window.location.href = fullPath;
      return null;
    }

    return <AdminPage {...routeProps} />;
  };

  const getCustomersPage = (routeProps) => {
    if (featureFlags.backofficeM1) {
      const { location } = routeProps;
      const fullPath = location.pathname + location.search;
      window.location.href = fullPath;
      return null;
    }

    return <AdminCustomersPage {...routeProps} />;
  };

  const homepagePath = featureFlags.homepageFP ? "/v2/homepage" : "/homepage";
  const getHomepage = (routeProps) => {
    if (featureFlags.homepageFP) {
      const { location } = routeProps;
      const fullPath = location.pathname + location.search;
      window.location.href = fullPath;
      return null;
    }

    return <SustellHomePage {...routeProps} />;
  };

  return (
    <>
      {featureFlags.notifications ? (
        <WelcomeModalInner
          open={open}
          onClose={() => {
            setOpen(false);
            localStorage.setItem("notificationsViewed", "true");
          }}
        />
      ) : (
        <NotificationsModal
          data={notifications}
          open={open && notifications?.length > 0}
          onClose={() => {
            setOpen(false);
            localStorage.setItem("notificationsViewed", "true");
          }}
        />
      )}
      <Suspense fallback={<LayoutSplashScreen />}>
        <Switch>
          {/*  safeguarding direct access to urls */}
          {!Can("access", "Admin pages") && (
            <Redirect exact from={usersPath} to={homepagePath} />
          )}
          {!Can("access", "Admin pages") && (
            <Redirect exact from={`${usersPath}/*`} to={homepagePath} />
          )}
          {!Can("access", "Admin pages") && !Can("read", "Customer") && (
            <Redirect exact from={customersPath} to={homepagePath} />
          )}
          {/* once FF_BACKOFFICE_M1 is on, the legacy /admin/users(*) and /admin/customers urls are retired */}
          {featureFlags.backofficeM1 && (
            <Redirect exact from="/admin/users" to={usersPath} />
          )}
          {featureFlags.backofficeM1 && (
            <Redirect exact from="/admin/users/*" to={usersPath} />
          )}
          {featureFlags.backofficeM1 && (
            <Redirect exact from="/admin/customers" to={customersPath} />
          )}
          {featureFlags.backofficeM1 && (
            <Redirect exact from="/backoffice" to={customersPath} />
          )}
          {!Can("access", "Management pages") && (
            <Redirect exact from="/" to={homepagePath} />
          )}
          {Can("onlyAccess", "Dashboard") && (
            <Redirect exact from={homepagePath} to="/mydashboard" />
          )}
          {Can("access", "Admin pages") && (
            <Redirect exact from="/admin" to={usersPath} />
          )}
          {Can("access", "Management pages") && (
            <Redirect exact from="/" to={homepagePath} />
          )}
          {!Can("access", "Dashboard") && (
            <Redirect exact from="/mydashboard*" to={homepagePath} />
          )}
          <ContentRoute
            path={homepagePath}
            render={(routeProps) => getHomepage(routeProps)}
          />
          <ContentRoute
            path={usersPath}
            render={(routeProps) => getUsersPage(routeProps)}
          />
          <ContentRoute
            path={customersPath}
            render={(routeProps) => getCustomersPage(routeProps)}
          />
          <ContentRoute
            path="/admin/notifications"
            component={NotificationPage}
          />
          <ContentRoute path="/admin/helpcenter" component={HelpCenterPage} />
          <ContentRoute
            exact
            path="/v2/ingredients"
            render={(routeProps) => getMyIngredientsPage(routeProps)}
          />
          {featureFlags.feedV2Routing && (
            <ContentRoute
              exact
              path="/v2/feeds"
              render={(routeProps) => getMyFeedsPage(routeProps)}
            />
          )}
          {!featureFlags.feedV2Routing && (
            <ContentRoute
              exact
              path="/customers/:customerID/myfeeds"
              render={(routeProps) => getMyFeedsPage(routeProps)}
            />
          )}
          {featureFlags.farmV2Routing && (
            <ContentRoute
              exact
              path="/v2/farms"
              render={(routeProps) => getMyFarmsPage(routeProps)}
            />
          )}
          <ContentRoute
            exact
            path="/customers/:customerID/myfarms"
            render={(routeProps) => getMyFarmsPage(routeProps)}
          />
          {/* TODO: remove old dashboard when not needed anymore and change path for new to be 'mydashboard' */}
          <ContentRoute
            exact
            path="/mydashboard"
            component={SustellDashboardPage}
          />
          <ContentRoute
            exact
            path="/mydashboard/:dashboardName"
            component={SustellDashboardPage}
          />
          <ContentRoute
            exact
            path="/footprints/:customerID/:baselineFarmID/:baselineProcessID/:baselineType?/:baselineReference?/:comparisonFarmID?/:comparisonProcessID?/:comparisonType?/:comparisonReference?/:comparisonCustomerID?"
            component={FootPrintPage}
          />
          {!featureFlags.feedV2Routing && (
            <ContentRoute
              exact
              path="/feed-footprints/:customerID/:baselineType?/:baselineReference?/:comparisonType?/:comparisonReference?/:comparisonCustomerID?"
              component={FootPrintPage}
            />
          )}
          <ContentRoute
            exact
            path="/customers/:customerID/farm/:farmID"
            component={SustellFarmPage}
          />
          <ContentRoute
            exact
            path="/customers/:customerID/farm/:farmID"
            component={FarmFormPage}
          />
          <ContentRoute
            exact
            path="/customers/:customerID/farm/:farmID/pp/:processID"
            component={SustellProdProcessDatasetsPageV2}
          />
          {(featureFlags.roiCalculatorPoultry ||
            featureFlags.roiCalculatorPig) && (
            <ContentRoute
              exact
              path="/customers/:customerID/farm/:farmID/pp/:processID/roi/:interventionId"
              component={SustellRoiCalculatorPage}
            />
          )}
          {(featureFlags.roiCalculatorPoultry ||
            featureFlags.roiCalculatorPig) && (
            <ContentRoute
              exact
              path="/customers/:customerID/farm/:farmID/pp/:processID/roi/:interventionId/results"
              component={SustellRoiResultsPage}
            />
          )}
          <ContentRoute
            exact
            path="/customers/:customerID/farm/:farmID/pp/:processID/nds/:datasetID"
            component={SustellDatasetMainPage2}
          />
          <ContentRoute
            exact
            path="/customers/:customerID/farm/:farmID/pp/:processID/nint/:interventionID"
            component={SustellInterventionMainPage_v2}
          />
          {!featureFlags.feedV2Routing && (
            <ContentRoute
              exact
              path="/customers/:customerID/compoundfeeds/:feedID?/:formType?"
              component={CompoundFeedPage}
            />
          )}
          {!featureFlags.feedV2Routing && (
            <ContentRoute
              exact
              path="/customers/:customerID/newfeed"
              children={redirectFeed}
            />
          )}
          <ContentRoute exact path="/signout" component={SignOut} />
          <ContentRoute
            exact
            path="/customers/:customerID/facilities/:facilityID"
            component={FacilityFormPage}
          />
          <ContentRoute
            exact
            path="/customers/:customerID/facilities"
            component={FacilitiesTable}
          />
          <ContentRoute
            path="/v2/profile"
            render={(routeProps) => getMyProfilePage(routeProps)}
          />
          <ContentRoute path="/helpcenter" component={HelpCenter} />
          <Redirect to="error/error-v1" />
        </Switch>
      </Suspense>
      {selectedCustomer?.id && (
        <AccessSampleDataDialog
          open={requestAccessDialog}
          title={intl.formatMessage({
            id: "POST.LOGIN.REQUEST.ACCESS.SAMPLE.DATA",
          })}
          onClose={() => {
            setRequestAccessDialog(false);
          }}
          isShowPostLogin
          customerID={selectedCustomer.id}
        />
      )}
    </>
  );
}
